import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="bg-muted border-t border-border py-4 px-5 text-center text-muted-foreground">
      <p className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1">
        <span>&copy; 2026 Pheefee. All rights Reserved.</span>
        <span className="text-border">|</span>
        <Link
          to="/about/user-privacy-policy"
          className="text-muted-foreground hover:text-primary transition-colors no-underline"
        >
          User Privacy Policy
        </Link>
        <span className="text-border">|</span>
        <Link
          to="/about/customer-terms-and-conditions"
          className="text-muted-foreground hover:text-primary transition-colors no-underline"
        >
          Customer Terms &amp; Conditions
        </Link>
        <span className="text-border">|</span>
        <Link
          to="/about/trainer-terms-and-conditions"
          className="text-muted-foreground hover:text-primary transition-colors no-underline"
        >
          Trainer Terms &amp; Conditions
        </Link>
      </p>
    </footer>
  );
};

export default Footer;
